export default __webpack_public_path__ + "static/media/4.8ddc7f60.jpg";